"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = void 0;
const SinkBuilder_1 = require("../SinkBuilder");
/**
 * assign property to be the state property to hold the state inside sink
 * the `action.type` will be `{namespace}/{state name}`,
 * @param target prototype
 * @param name state property name in sink
 */
function state(target, name) {
    const sinkBuilder = SinkBuilder_1.SinkBuilder.get(target);
    sinkBuilder.state[name] = undefined;
}
exports.state = state;
